import * as React from "react";
import PropTypes from "prop-types";
const SvgSportsEBikeRideNormalXsmall = React.forwardRef(
  ({ color = "currentColor", size = 16, title, titleId, ...props }, ref) => (
    <svg
      fill={color}
      viewBox="0 0 16 16"
      xmlns="http://www.w3.org/2000/svg"
      ref={ref}
      width={size}
      height={size}
      aria-labelledby={titleId}
      {...props}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <g fill="">
        <path d="M13.397.162l-1.679 2.309c-.16.22-.003.529.27.529H13v1.733c0 .313.393.453.591.21l1.964-2.399A.333.333 0 0015.297 2H14V.358a.333.333 0 00-.603-.196zM8.807 4.33a.625.625 0 01.526-.288h2.625v1.25h-1.646l1.307 2.82a3.502 3.502 0 11-1.134.527l-.413-.89L7.87 11.68a.625.625 0 01-.545.32h-.344a3.508 3.508 0 11-2.47-3.854l.427-.87-.586-1.026H3V5h3v1.25h-.209l1.863 3.26 1.77-3.162-.658-1.419a.625.625 0 01.04-.599zm-4.18 6.42h2.296L5.687 8.587zM3.95 9.293A2.258 2.258 0 105.711 12H3.625a.625.625 0 01-.561-.9zm7.075.51a2.253 2.253 0 101.134-.526l1.172 2.527-1.134.526z" />
      </g>
    </svg>
  )
);
SvgSportsEBikeRideNormalXsmall.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  title: PropTypes.string,
  titleId: PropTypes.string,
};
export default SvgSportsEBikeRideNormalXsmall;
